import {Component, Input, ViewEncapsulation, Output, EventEmitter, OnDestroy} from '@angular/core';

@Component({
  selector: 'app-modal-basic',
  templateUrl: './modal-basic.component.html',
  styleUrls: ['./modal-basic.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalBasicComponent implements OnDestroy {
  @Input() modalClass: string;
  @Input() dialogClass: string;
  @Input() hideBackground = false;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  @Input() hideOnClickOutside = false;
  @Input() zIndex = 1050;
  @Output() open = new EventEmitter();
  @Output() close = new EventEmitter();

  public visible = false;
  public visibleAnimate = false;

  constructor() {
  }

  ngOnDestroy(): void {
    this.hide();
  }

  public show(): void {
    this.visible = true;
    document.getElementsByTagName('body')[0].classList.add('modal-open');
    setTimeout(() => {
      this.visibleAnimate = true;
      this.open.emit();
    }, 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
    setTimeout(() => {
      this.visible = false;
      this.close.emit();
    }, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal') && this.hideOnClickOutside) {
      this.hide();
    }
  }

}
